import {
  Dialog,
  DialogActions,
  DialogActionsProps,
  DialogContent,
  DialogProps,
  DialogTitle,
  DialogTitleProps,
} from '@mui/material';
import { CloseIcon } from '../../../primitives/interactive-icons/close-icon';

export type SimpleDialogProps = Omit<DialogProps, 'open' | 'onClose'> & {
  open?: boolean;
  /** Closes from the close button, Escape and the backdrop; without it, the actions must close it. */
  onClose?: () => void;
};

export const SimpleDialogTitle = ({ sx, ...props }: DialogTitleProps) => (
  // Clear of the close button the dialog places over its top right.
  <DialogTitle {...props} sx={[{ pr: 8 }, ...(Array.isArray(sx) ? sx : [sx])]} />
);

export const SimpleDialogActions = ({ sx, ...props }: DialogActionsProps) => (
  <DialogActions
    {...props}
    sx={[
      { px: 3, py: 1, bgcolor: 'grey.50', borderTop: 1, borderColor: 'divider' },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);

/**
 * A dialog composed from `SimpleDialog.Title`, `SimpleDialog.Content` and `SimpleDialog.Actions`,
 * each styled by default and open to `sx`; the dialog itself takes MUI's `Dialog` props.
 */
export function SimpleDialog({ open = true, onClose, children, ...props }: SimpleDialogProps) {
  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={onClose} {...props}>
      {onClose && <CloseIcon onClick={onClose} sx={{ position: 'absolute', top: 12, right: 16 }} />}
      {children}
    </Dialog>
  );
}

SimpleDialog.Title = SimpleDialogTitle;
SimpleDialog.Content = DialogContent;
SimpleDialog.Actions = SimpleDialogActions;
